import { INITIALIZE_FORM } from '../actionTypes';
import { profileActions } from '../reducer';

export default (values) => profileActions[INITIALIZE_FORM](values);
